import React from 'react';
import { AuthProvider, useAuth } from './context/AuthContext';
import { AppProvider }           from './context/AppContext';
import { ToastProvider }         from './context/ToastContext';

// Auth screens
import LoginPage           from './pages/LoginPage';
import RegisterPage        from './pages/RegisterPage';
import OtpPage             from './pages/OtpPage';
import PendingApprovalPage from './pages/PendingApprovalPage';
import AddPropertyPage     from './pages/AddPropertyPage';

// Main app shell
import AppShell from './components/layout/AppShell';

/* ── Router (auth-based) ─────────────────────────────────────────────────── */
const AppRouter = () => {
  const { screen, user } = useAuth();

  // Mobile app shell wrapper — keeps everything constrained to 430px max-width
  const wrap = (children) => (
    <div className="app-shell">
      {children}
    </div>
  );

  // If authenticated, always show the app — block access to auth screens
  if (user) {
    return (
      <AppProvider>
        <AppShell />
      </AppProvider>
    );
  }

  switch (screen) {
    case 'login':    return wrap(<LoginPage />);
    case 'register': return wrap(<RegisterPage />);
    case 'otp':           return wrap(<OtpPage />);
    case 'add-property':  return wrap(<AddPropertyPage />);
    case 'pending':       return wrap(<PendingApprovalPage />);
    case 'app':      return (
      <AppProvider>
        <AppShell />
      </AppProvider>
    );
    default:         return wrap(<LoginPage />);
  }
};

/* ── Root App ────────────────────────────────────────────────────────────── */
const App = () => (
  <div
    style={{
      height: '100dvh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#f8fafc',
    }}
  >
    <ToastProvider>
      <AuthProvider>
        <AppRouter />
      </AuthProvider>
    </ToastProvider>
  </div>
);

export default App;
